import { render, staticRenderFns } from "./VideoMain.vue?vue&type=template&id=7b3eab9b&lang=pug"
import script from "./VideoMain.vue?vue&type=script&lang=ts"
export * from "./VideoMain.vue?vue&type=script&lang=ts"
import style0 from "./VideoMain.vue?vue&type=style&index=0&id=7b3eab9b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports